module.exports = __webpack_public_path__ + "static/media/carousel-slide-modal-1.7c359f78.webp";